import { $get } from "@/utils/request";

// 分享详情
export const getShareDetail = (share_code:string) => {
  return $get(`/v1/share/detail`, { share_code }).then((res: any) => res.data)
}
